import AsyncView from '../../helpers/AsyncView';
import Modal from '../Modal';
import Product from './Product';

const selectors = {
  modalContent: '[data-dialog-content]',
  modalProduct: '[data-product]',
};

/**
 * Container class for quickshop.
 * Exported as singleton instance for ease of use across components.
 *
 * @class QuickShop
 */
class QuickShop {
  constructor() {
    this.modalContent = document.querySelector(selectors.modalContent);
  }

  /**
   * Set up a modal instance
   */
  _initModal() {
    this.modal = new Modal();
  }

  _onModalOpen = () => {
    const product = this.modalContent.querySelector(selectors.modalProduct);

    // Create a new Product instance for the requested quickshop product
    new Product(product, {
      isQuickShop: true,
    });
  };

  /**
   * Open a quickshop
   *
   * @param {string} url The product url
   * @param {string} hash The product json hash to compare to what may be in storage
   */
  async open(url, hash) {
    const { html } = await AsyncView.load(url, { view: 'quickshop' }, { hash });

    this._initModal();

    this.modal.open(html.content);
    this._onModalOpen();
  }

  /**
   * Close a quickshop
   */
  close() {
    this.modal.close();
  }
}

export default new QuickShop();
